import { createStyles, Modal, Tabs } from '@mantine/core';
import { Prism } from '@mantine/prism';
import type { LineageFlowCreationQuery } from '@repo/api-codegen';

interface CreationQueryModalProps {
	opened: boolean;
	onClose: () => void;
	creationQueries: LineageFlowCreationQuery[];
}

const useStyles = createStyles((theme) => ({
	prism: {
		overflowY: 'auto',
		'.mantine-Prism-code': {
			fontSize: theme.fontSizes.xs,
		},
	},
}));

function CreationQueryModal({
	opened,
	onClose,
	creationQueries,
}: CreationQueryModalProps) {
	const { classes } = useStyles();

	return (
		<Modal title="Creation queries" size="xl" opened={opened} onClose={onClose}>
			<Tabs defaultValue="0">
				<Tabs.List>
					{creationQueries.map((_, index) => (
						<Tabs.Tab key={index} value={String(index)}>
							Query {index + 1}
						</Tabs.Tab>
					))}
				</Tabs.List>
				{creationQueries.map((q, index) => (
					<Tabs.Panel key={index} value={String(index)} pt="md">
						<Prism language="sql" className={classes.prism}>
							{q?.sql ?? ''}
						</Prism>
					</Tabs.Panel>
				))}
			</Tabs>
		</Modal>
	);
}

export default CreationQueryModal;
